import { render, staticRenderFns } from "./TechStack.vue?vue&type=template&id=6cc4ffcd&scoped=true&"
import script from "./TechStack.vue?vue&type=script&lang=js&"
export * from "./TechStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc4ffcd",
  null
  
)

export default component.exports